import Api from '../api';
let uri = '/api/ed/distribucion'

export const getDistribuciones = () => {
    return Api.getInstance().executeGetQuery(uri)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}
